import { useTranslation } from 'react-i18next';

/**
 * Translations for updating a recurring payment.
 */
const useUpdateTranslations = () => {
  const prefix = 'account.recurringPayment.update.';

  const { t } = useTranslation();
  const update = (translationKey: string) => t(`${prefix}${translationKey}`);

  return {
    chatToAnAgent: update('chatToAnAgent'),
    chatToAnAgentText: update('chatToAnAgentText'),
    monthly: update('monthly'),
    paymentDate: {
      change: update('changePaymentDate'),
      select: update('selectPaymentDate'),
    },
    datePickerText: update('datePickerText'),
    processingUpdate: update('processingUpdate'),
    success: {
      heading: update('success.heading'),
      text: update('success.text'),
    },
    failure: {
      heading: update('failure.heading'),
      text: update('failure.text'),
    },
  };
}

export default useUpdateTranslations;